import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Page from "../../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {TabViewItem} from "../../../../../components/BaseComponents/TabView";
import TimeoffRequestsPermessiTab from "./TimeoffRequestsPermessiTab";
import TimeoffRequestsFerieTab from "./TimeoffRequestsFerieTab";
import TimeoffRequestsBustePagaTab from "./TimeoffRequestsBustePagaTab";
import TimeoffRequestsFilesTab from "./TimeoffRequestsFilesTab";
import ExpensesTab from "./ExpensesTab";
import AwayTripsTab from "./AwayTripsTab";

const TAB_PERMESSI = "permessi";
const TAB_FERIE = "ferie";
const TAB_BUSTE_PAGA = "buste_paga";
const TAB_FILES = "files";
const TAB_EXPENSES = "expenses";
const TAB_AWAY_TRIPS = "away_trips";

export default class SelfCareDipendenteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: TAB_PERMESSI
        };
        this.activeTabColor = "#293069";
    }

    handleTabChange = tab => _ => this.setState({activeTab: tab});

    render() {
        return (
            <Fragment>
                <Page
                    title={"Area dipendente"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={this.props.active}
                    content={
                        <div>
                            <div className={"d-flex bg-white sticky-top shadow-sm"}>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_PERMESSI)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_PERMESSI ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Permessi
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_FERIE)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_FERIE ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Ferie
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_BUSTE_PAGA)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_BUSTE_PAGA ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Paghe
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_FILES)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_FILES ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Files
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_EXPENSES)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_EXPENSES ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Spese
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_AWAY_TRIPS)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_AWAY_TRIPS ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Trasferte
                                </TabViewItem>
                            </div>

                            {
                                this.state.activeTab === TAB_PERMESSI &&
                                <TimeoffRequestsPermessiTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_FERIE &&
                                <TimeoffRequestsFerieTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_BUSTE_PAGA &&
                                <TimeoffRequestsBustePagaTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_FILES &&
                                <TimeoffRequestsFilesTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_EXPENSES &&
                                <ExpensesTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_AWAY_TRIPS &&
                                <AwayTripsTab
                                    staffList={this.props.staffList}
                                />
                            }
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

SelfCareDipendenteModal.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    staffList: PropTypes.array
};
